module.exports = __webpack_public_path__ + "static/media/table3-ocean.8ede29bb.png";